<div class="modal-body">
  <div class="row p-3 mx-0">
    <div class="col-sm-12 text-center">
      <h4>{{typeaction}} Category</h4>
      <hr>
      <div class="form-group">
        <input [(ngModel)]="categoryName" required  type="text" class="form-control" name="categoryName" placeholder="Category Name">
      </div>
      <div class="form-group">
        <button *ngIf='typeaction=="Add"' class="btn btn-info mx-1" (click)="addCategory(categoryName)">ADD</button>
        <button *ngIf='typeaction=="Edit"' class="btn btn-info mx-1" (click)="editCategory(categoryName)">EDIT</button>
        <button class="btn btn-danger mx-1" (click)="close()">CANCEL</button>
      </div>
    </div>
  </div>
</div>
